import { BCMSDate } from "@bcm-dev/bcms-vite";
import DatePicker, { formatPickerString } from "../..";
import CalendarIcon from '../../../../../res/img/calendar-icon.svg?react';
import "./styles.css";

export default function DatePickerView(props) {
  const use = controllers => {
    const showValue = evt => controllers.open();
    const value = props.setDate;
    const labelClass = value instanceof BCMSDate ? "floating-label" : "";
    const dataPoint = props.dataPoint ? { "data-point" : props.dataPoint } : {};

    // START: Set data points.
    const calendarIconDataPoint = props.dataPoint ? { "data-point" : props.dataPoint + "_Calendar_Icon" } : {};
    const selectedDateInputLabelDataPoint = props.dataPoint ? { "data-point" : props.dataPoint + "_Selected_Date_Input_Label" } : {};
    const floatingLabelDataPoint = props.dataPoint ? { "data-point" : props.dataPoint + "_Floating_Label" } : {};
    const rightLabelDataPoint = props.dataPoint ? { "data-point": props.dataPoint + "_Right_Label" } : {};
    // END: Set data points.

    return (
      <div className="date-label">
        <div className="floating-label-input-container">
          { value instanceof BCMSDate && <span { ...selectedDateInputLabelDataPoint }>{ formatPickerString(controllers.get() ,props.showWords)}</span> }
          <label className={ `${ labelClass } form-row-label` } { ...floatingLabelDataPoint }>{ props.dateLabel }</label>
          <p className="right-label sub-text" { ...rightLabelDataPoint }>{ props.rightLabel }</p>
          <span onClick={ showValue } { ...calendarIconDataPoint }><CalendarIcon className="icon blue-icon calendar-icon clickable" /></span>
        </div>
        
        <div className={ `calendar-info-text-container flex-container flex-horizontal align-center space-between` }>
          <span className={ `form-row-info-text gray-text flex-width` }>
            { props.children }
          </span>
          <span className="form-row-info-text gray-text form-row-info-text-right set-width">
            { props.infoTextRight }
          </span>
        </div>
            
      </div>
    );
  }

  return <DatePicker disableWeekends={props.disableWeekends} disableToday={props.disableToday} setDate={ props.setDate } enablePast={ props.enablePast } onChange={ props.onChange } use={ use } showFees={ props.showFees } billerType={ props.billerType } conditionalDisable={ props.conditionalDisable } dueDate={ props.dueDate } />
}